module.exports = __webpack_public_path__ + "static/service02-6be15768d724fc2f61c8015207dd3669.png";